import React from 'react';
import styled from 'styled-components';
import { TextArea, DialogBody, Typography } from '@dev/ee-components';

import { EditMimeModalBodyProps } from './EditMimeModalBodyInterface';

const ContentWrapper = styled.div`
    textarea {
        margin-bottom: 8px;
    }
`;

const AlertWrapper = styled.div`
    margin-bottom: 24px;
`;

export const EditMimeModalBody = ({
    templateObject,
    contentType,
    alert,
    label,
    onChange,
}: EditMimeModalBodyProps): JSX.Element => {
    const defaultValue = templateObject?.Body?.Parts?.find((o) => o.ContentType === contentType)?.Content ?? '';
    return (
        <ContentWrapper>
            <AlertWrapper>
                <DialogBody variant="alert">
                    <Typography variant="body1" bodyVariant="onPaper">
                        {alert}
                    </Typography>
                </DialogBody>
            </AlertWrapper>
            <TextArea
                name="editMimeBodyTextarea"
                id="editMimeBodyTextarea"
                label={label}
                maxWidth={536}
                height={96}
                onChange={(e) => {
                    onChange?.(e.target.value);
                }}
                defaultValue={defaultValue}
            />
        </ContentWrapper>
    );
};
